import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "simplydo/core/helpers";

type GroupVisitMap = Record<string, string>;

const getStorageKey = (userId?: string, organisationId?: string) => {
  if (!userId || !organisationId) return null;
  return `groupVisits:${organisationId}:${userId}`;
};

const parseGroupVisits = (value: string | null): GroupVisitMap => {
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    if (!parsed || typeof parsed !== "object") return {};
    return Object.fromEntries(
      Object.entries(parsed).filter(
        ([groupId, visitedAt]) =>
          typeof groupId === "string" && typeof visitedAt === "string",
      ),
    ) as GroupVisitMap;
  } catch (_err) {
    return {};
  }
};

export const getStoredGroupVisits = (
  userId?: string,
  organisationId?: string,
) => {
  const storageKey = getStorageKey(userId, organisationId);
  if (!storageKey) return {};
  return parseGroupVisits(getLocalStorageItem(storageKey));
};

export const trackStoredGroupVisit = (
  userId: string,
  organisationId: string,
  groupId: string,
  lastVisitedAt: string,
) => {
  const storageKey = getStorageKey(userId, organisationId);
  if (!storageKey) return;
  const nextVisits = {
    ...getStoredGroupVisits(userId, organisationId),
    [groupId]: lastVisitedAt,
  };
  setLocalStorageItem(storageKey, JSON.stringify(nextVisits));
};
